import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const HeartHealthJumbotron = () => {
  return (
    <LandingPageJumbotron
      data-cy="heart-health-jumbotron"
      description="heart_health_testimonials_description"
      theme="brown"
      title="heart_health_testimonials_eyebrow"
    />
  );
};

export default HeartHealthJumbotron;
